import { MSection } from "components/misc";
import { Button } from "design-react-kit";
import React, { Component } from "react";
import { ReactMediaRecorder } from "react-media-recorder";
import { FaMicrophoneAlt, FaStop, FaRedo } from "react-icons/fa";

export class AudioRecorder extends Component {
  state = {
    recorderKey: 0,
  };

  resetRecording = () => {
    this.setState((state) => ({
      recorderKey: state.recorderKey + 1,
    }));
  };

  render() {
    return (
      <>
        <h2>Registratore vocale</h2>

        <MSection className="my-3">
          <ReactMediaRecorder
            key={this.state.recorderKey}
            audio
            render={({
              status,
              startRecording,
              stopRecording,
              mediaBlobUrl,
            }) => (
              <div>
                {!mediaBlobUrl && status !== "recording" ? (
                  <Button className="primary bg-dark" onClick={startRecording}>
                    <FaMicrophoneAlt className="mr-2" /> Registra
                  </Button>
                ) : null}

                {status === "recording" && (
                  <Button className="primary bg-dark" onClick={stopRecording}>
                    <FaStop className="mr-2" /> Interrompi
                  </Button>
                )}

                <hr />

                <div className="my-3">
                  {mediaBlobUrl && (
                    <>
                      <audio className="mr-3" src={mediaBlobUrl} controls />
                      <Button
                        className="my-2"
                        onClick={this.resetRecording}
                        color="primary bg-dark"
                      >
                        <FaRedo className="mr-2" />
                        Riprova
                      </Button>
                    </>
                  )}
                </div>
              </div>
            )}
          />
        </MSection>
      </>
    );
  }
}
